// extracted by mini-css-extract-plugin
module.exports = {"section":"NormalSection-module--section--26hv7"};